import { TieredMenu } from 'primereact/tieredmenu';
import {useNavigate} from 'react-router';
const Settings = ({children}) =>{
    const navigate = useNavigate();
    const items = [
        {   
            label: <b>Settings</b>,
        },
        {   
            label: 'Language',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/settings/language');
                // url: '/accesscontrol/createrole',  
            },
        },
        {
            label: 'Currency',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/settings/currency');
                // navigate('/accesscontrol/createpermisson'); 
            }
        },
        {
            label: 'Subscription',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/settings/subscription');
                // navigate('/accesscontrol/createpermisson'); 
            }
        },
        {
            label: 'Subs Permissions',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/settings/subspermissions');
                // navigate('/accesscontrol/createpermisson'); 
            }
        },
        {
            label: 'Subs config',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/settings/subsconfig');
                // navigate('/accesscontrol/createpermisson'); 
            }
        },
        {
            label: 'Assign permissions',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/settings/subscription');
                // navigate('/accesscontrol/createpermisson'); 
            }
        }
        // {
        //     label: 'Assign Role',
        //     icon: 'fa fa-angle-right',
        //     items: [
        //         {
        //             label: 'React.js',
        //             url: 'https://react.dev/'
        //         },
        //         {
        //             label: 'Vite.js',
        //             url: 'https://vitejs.dev/'
        //         }
        //     ]
        // }
    ];
    
    

    return (
         <>
            <div className='row'>
                <div className='col-md-2'><TieredMenu className="internalmenu" model={items} breakpoint="767px" /></div>
                <div className='col-md-10'>{children}</div>
            </div>

               {/* <div className="card">
                    <select className='form-control' onChange={updatelanguage}>
                        <option value="en">English</option>
                        <option value="hi">Hindi</option>
                    </select>
               </div> */}
         </>
    );  
} 

export default Settings;